import script from "./ConciergeQuestion.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConciergeQuestion.vue?vue&type=script&setup=true&lang=ts"

import "./ConciergeQuestion.vue?vue&type=style&index=0&id=1d5ce871&lang=scss&scoped=true"

import exportComponent from "/mnt/c/Users/mssuzuki/work/fidev/nicotto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d5ce871"]])

export default __exports__